import * as Sentry from '@sentry/browser';

const dev = window.location.host === 'localhost:3000';

export const logError = (err) => {
  dev ? console.log(err) : Sentry.captureException(err);
};

export const logMessage = (msg) => {
  dev ? console.log(msg) : Sentry.captureMessage(msg);
};

export const initLogger = (dsn) => {
  if (dev) {
    return;
  }

  Sentry.init({
    dsn: dsn,
    release: process.env.REACT_APP_VERSION,
    environment: 'production',
    attachStacktrace: true,
    sendDefaultPii: true,
    beforeSend(event) {
      return event;
    } 
  });
};

export const setTag = (key, value) => {
  Sentry.configureScope((scope) => {
    scope.setTag(key, value);
  });
};

export const setUser = (user) => {
  if (user) {
    Sentry.configureScope((scope) => {
      scope.setUser({
        username: user.username,
        email: user.attributes.email
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/utils/logger.js